import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import logo from "../../../sidebar-logo.png";
import userStore from "../../../Stores/User";
import { isPaidProUser, hasPaidPlan } from "../../../constants/plans";
import { createReactivationCheckoutSession } from "../../../audiblogsApi";

const MobileHeader = observer(({ mobileMode, search }) => {
  const displayText =
    mobileMode === "addArticle"
      ? "Add Article"
      : mobileMode === "settings"
      ? "Other"
      : mobileMode === "playlist"
      ? "Playlist"
      : search.trim().length > 0
      ? "Search"
      : "Feeds";

  const hasPlan = hasPaidPlan(userStore.user);
  const isPro = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id 
    ? isPaidProUser(userStore.user)
    : false;

  const badgeStyle = {
    background: isPro
      ? 'linear-gradient(135deg, #CB5EEE 0%, #4BE1EC 100%)'
      : hasPlan
      ? 'linear-gradient(135deg, #FFB347 0%, #FFCC33 100%)'
      : 'linear-gradient(135deg, #FF6B6B 0%, #FFE66D 100%)',
    padding: '2px 6px',
    borderRadius: '8px',
    fontSize: '11px',
    fontWeight: 'bold',
    color: 'white',
    cursor: isPro ? 'default' : 'pointer',
    width: isPro ? '45px' : hasPlan ? '70px' : '95px',
    whiteSpace: 'nowrap',
    margin: '60px auto 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
  };

  const handleBadgeClick = () => {
    if (!isPro) {
      // Check if user has a customer_id but no active subscription (cancelled)
      const hasStripeCustomerId = userStore.user?.stripe_customer_id || userStore.user?.customer_id;
      const hasActiveSubscription = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;
      
      if (hasStripeCustomerId && !hasActiveSubscription) {
        createReactivationCheckoutSession(userStore.idToken, {}, '/add')
          .then(response => {
            if (response.data.url) {
              window.location.href = response.data.url;
            } else {
              window.location.href = '/onboarding/choosevoice';
            }
          })
          .catch(() => {
            window.location.href = '/onboarding/choosevoice';
          });
      } else if (hasStripeCustomerId) {
        // User has active subscription - send to customer portal
        window.location.href = userStore.customerPortalUrl;
      } else {
        // User has no Stripe customer - send to onboarding
        window.location.href = '/onboarding/choosevoice';
      }
    }
  };

  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ 
        display: "flex", 
        flexDirection: "column",
        alignItems: "center"
      }}>
        <img src={logo} className="logo" />
        {isPro ? (
          <div style={badgeStyle}>PRO</div>
        ) : (
          <button
            style={badgeStyle}
            onClick={handleBadgeClick}
          >
            UPGRADE
          </button>
        )}
      </div>
      {/* <div className="display-text">{displayText}</div> */}
    </div>
  );
});

export default MobileHeader;
